import { usePostManager } from './usePostManager';
import { useDomParser } from './useDomParser';
import { messageBusUtil, useMessageBusDispatch } from '../../context/messagebus';
export const usePostHandler = ({
  topic,
  reply,
  edit,
  isTypeTopic,
  updateTopicPost,
  updateTopicReplies,
  trackForum
}) => {
  var _topic$first;
  const {
    handlePost
  } = usePostManager();
  const messageBusDispatch = useMessageBusDispatch();
  const {
    displayEditAtMentions
  } = useDomParser();
  const {
    getParser
  } = useDomParser();
  const parser = getParser();
  const existingContent = isTypeTopic ? {
    raw: topic === null || topic === void 0 || (_topic$first = topic.first) === null || _topic$first === void 0 || (_topic$first = _topic$first.post) === null || _topic$first === void 0 ? void 0 : _topic$first.cooked
  } : {
    raw: reply === null || reply === void 0 ? void 0 : reply.cooked
  };
  existingContent.raw = displayEditAtMentions(parser, existingContent.raw);
  const handlePostWrapper = async data => {
    return await handlePost({
      data,
      topic,
      reply,
      edit,
      isTypeTopic,
      messageBusUtil,
      messageBusDispatch,
      updateTopicPost,
      updateTopicReplies,
      trackForum
    });
  };
  return {
    existingContent,
    handlePostWrapper
  };
};
//# sourceMappingURL=usePostHandler.js.map